import * as React from 'react'
import { styled } from 'next-yak'

import { COLORS, BREAKPOINTS, glyphs } from '@ulule/owl-kit-components/next'

import { EDIT_MODE_LAPTOP_BREAKPOINT } from '../constants'

type CreateButtonProps = {
  center?: boolean
  createHandler: () => void
  cta?: React.ReactNode
  direction?: 'column' | 'row'
  mode?: 'small' | 'normal'
  title: React.ReactNode
  isVerticalNavMenu?: boolean
}

const Icon = styled.div<{ $mode: CreateButtonProps['mode'] }>`
  align-items: center;
  background-color: ${COLORS.PRIMARY_BLUE_200};
  border-radius: 100%;
  display: flex;
  height: ${({ $mode }) => ($mode === 'small' ? '27px' : '36px')};
  justify-content: center;
  width: ${({ $mode }) => ($mode === 'small' ? '27px' : '36px')};
  transition: 0.3s ease;

  &:focus,
  &:hover,
  &:active {
    outline: none;
  }

  > ${glyphs.stroke.Plus} {
    color: ${COLORS.PRIMARY_BLUE_500};
    fill: ${COLORS.PRIMARY_BLUE_500};
    position: relative;
    top: -1px;
  }
`

const Heading = styled.div<{
  $center?: boolean
  $direction: CreateButtonProps['direction']
}>`
  align-items: center;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;
  position: relative;
  top: -25%;

  @media screen and ${EDIT_MODE_LAPTOP_BREAKPOINT} {
    position: initial;
    top: initial;
  }

  @media screen and ${BREAKPOINTS.LAPTOP} {
    flex-direction: ${({ $direction }) => $direction};
    justify-content: ${({ $center }) => ($center ? 'center' : 'left')};
    margin: 0;

    ${Icon} {
      margin-right: ${({ $direction }) => ($direction === 'column' ? '0px' : '15px')};
    }
  }
`

export function CreateButton({
  center,
  createHandler,
  cta,
  direction = 'row',
  mode,
  title,
}: CreateButtonProps): React.ReactElement<CreateButtonProps> {
  return (
    <>
      <Heading
        $center={center}
        $direction={direction}
        onClick={() => {
          createHandler()
        }}
      >
        <Icon $mode={mode}>
          <glyphs.stroke.Plus size={mode === 'small' ? 12 : 20} />
        </Icon>
        {title}
      </Heading>
      {cta}
    </>
  )
}
